// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"e7489cd86dab6b532e51","655":"bad1c24b68d3ac420d5a"}[chunkId] + ".js";
};